export default __webpack_public_path__ + "static/media/espa.e9c02bb0.png";